module.exports = __webpack_public_path__ + "static/media/user.616cd7a1.svg";